module.exports = __webpack_public_path__ + "img/shoulder_width.e9eda4ff.png";